import { ContentTypesEnum } from "enums";

export const LICENCE_CONTENT = [ContentTypesEnum.Flows];
